module.exports = __webpack_public_path__ + "img/bookmark.e562b64c.svg";